import React, { Component, Fragment } from 'react';
import { withApollo } from 'react-apollo';
import { AppContext } from '../../AppProvider';
import { withNamespaces } from 'react-i18next';
import {
  withCombinedStyles,
  withComposedEnhancers
} from '../../utils/hocUtils';
import TypographyStyles from '../../styles/typography';
import LayoutStyles from '../../styles/layout';
import ReportStyles from './Report.styles';
import classnames from 'classnames';

import Grid from '@material-ui/core/Grid';
import InvoiceBatchesSummary from '../../components/reports/summaryCards/InvoiceBatches';
import CarrierPerformanceSummary from '../../components/reports/summaryCards/CarrierPerformance';

// import * as DataAccess from './ReportIndex.data.mock.js';
import * as DataAccess from './ReportIndex.data.js';

import {
  isPermissible,
  isPropelAdministrator
} from '../../components/Global/PermissionResolver';
import { ADMIN, SHIPPER } from '../../constants/permissions';

const CardNames = {
  InvoiceBatch: 'invoice',
  CarrierPerformance: 'carrierPerformance'
};
const UninitializedCard = {
  data: {},
  loading: true,
  error: false
};
export class ReportsIndex extends Component {
  state = {
    [CardNames.InvoiceBatch]: UninitializedCard,
    [CardNames.CarrierPerformance]: UninitializedCard
  };

  async componentDidMount() {
    await Promise.all([
      this._loadInvoiceBatchData(),
      this._loadCarrierPerformanceData()
    ]);
  }

  setCardStateElement = (name, element, value) => {
    this.setState({
      [name]: {
        ...this.state[name],
        [element]: value
      }
    });
  };

  _loadInvoiceBatchData = async () => {
    const { client: ApolloClient } = this.props;
    const { orgId } = this.context.globalProps.orgInfo;

    await this._loadCardData(
      CardNames.InvoiceBatch,
      async () =>
        await DataAccess.retrieveInvoiceBatchSummaryCardData(
          orgId,
          ApolloClient
        )
    );
  };

  _loadCarrierPerformanceData = async () => {
    const { client: ApolloClient } = this.props;
    const { orgId } = this.context.globalProps.orgInfo;

    await this._loadCardData(
      CardNames.CarrierPerformance,
      async () =>
        await DataAccess.retrieveCarrierPerformanceSummaryCardData(
          orgId,
          ApolloClient
        )
    );
  };

  _loadCardData = async (cardName, retriever) => {
    this.setCardStateElement(cardName, 'loading', true);

    try {
      const data = await retriever();

      this.setCardStateElement(cardName, 'data', data);
    } catch (error) {
      this.setCardStateElement(cardName, 'error', true);
    } finally {
      this.setCardStateElement(cardName, 'loading', false);
    }
  };

  render() {
    const { t, classes } = this.props;
    const canSeeInvoiceData =
      isPropelAdministrator(this.context.globalProps) &&
      (isPermissible(this.context.globalProps, ADMIN, true) ||
        isPermissible(this.context.globalProps, SHIPPER, true));

    return (
      <Fragment>
        <div className={classnames(classes.titleRootWrapper)}>
          <h1 className={classes.headline4}>{t('Reports')}</h1>
        </div>
        <Grid container spacing={24}>
          {canSeeInvoiceData && (
            <Grid item xs={6}>
              <InvoiceBatchesSummary
                fillHeight
                lastBatch={this.state[CardNames.InvoiceBatch].data.lastBatch}
                batchCount={this.state[CardNames.InvoiceBatch].data.batchCount}
                error={this.state[CardNames.InvoiceBatch].error}
                loading={this.state[CardNames.InvoiceBatch].loading}
              />
            </Grid>
          )}
          <Grid item xs={6}>
            <CarrierPerformanceSummary
              fillHeight
              data={this.state[CardNames.CarrierPerformance].data}
              error={this.state[CardNames.CarrierPerformance].error}
              loading={this.state[CardNames.CarrierPerformance].loading}
            />
          </Grid>
        </Grid>
      </Fragment>
    );
  }
}

ReportsIndex.contextType = AppContext;
export default withComposedEnhancers(
  ReportsIndex,
  withNamespaces(),
  withCombinedStyles(true, TypographyStyles, LayoutStyles, ReportStyles),
  withApollo
);
